import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import VideoModal from './components/VideoModal';
import PostsFilter from './components/PostsFilter';
import Quiz from './components/Quiz';
import Tooltip from './components/Tooltip';
import PostcodeCheck from './components/PostcodeCheck';
import IEcheck from './components/IEcheck';
import StickyMenu from './components/StickyMenu';
import ScrollTo from './components/ScrollTo';
import CampagnesModule from './components/CampagneModule';
import TableOfContent from './components/TableOfContent';
import Accordion from './components/Accordion';
import ArticleMenu from './components/ArticleMenu';
import CalculateReadingTime from './components/CalculateReadingTime';
import QuestionAnswer from './components/QuestionAnswer';
import { createApp } from 'vue';
import LandingPageMap from '../../campagnes/watermonsters/assets/js/vue/LandingPageMap.vue';
import MapInput from './vue/GForms/MapInput.vue';
import ImageUpload from './vue/GForms/ImageUpload.vue';
import StadsnatuurMap from '../../campagnes/stadsnatuur/assets/js/vue/StadsnatuurMap.vue';
import CopyLink from './components/CopyLink';
import CopyToClipboard from './components/CopyToClipboard';
import Fade from './components/Fade';
import Carousel from './components/Carousel';
import ScrollText from './components/ScrollText';
import ModuleMenu from './components/ModuleMenu';
import HorizontalCarousel from './components/HorizontalCarousel';
import PageProgress from './components/PageProgress';

require('a11y_accordions');

export class NatuurEnMilieu {
	constructor() {
		Promise.all([NatuurEnMilieu.domReady()]).then(() => this.init());
	}

	init() {
		//handle gforms ajaxy content
		document.addEventListener('gform/post_render', ({ detail }) => {
			const { formId, currentPage } = detail;
			const form = document.querySelector(`#gform_wrapper_${formId}`);

			if (form) {
				form.dispatchEvent(
					new CustomEvent('bless', {
						bubbles: true,
					})
				);
			}
		});

		document.addEventListener('bless', (e) => {
			const vueRoots = e.target.querySelectorAll('.vue-root');

			vueRoots.forEach((el) => {
				if (el.hasAttribute('data-v-app')) {
					console.log('Not reinstantiating vue app');
					return;
				}
				createApp({
					components: {
						'map-input': MapInput,
						'image-upload': ImageUpload,
						'landing-page-map': LandingPageMap,
						'stadsnatuur-map': StadsnatuurMap,
					},
				}).mount(el);
			});

			this.copyLinkButton = e.target.querySelector('[data-button-share]');
			if (this.copyLinkButton) {
				new CopyLink(this.copyLinkButton);
			}
		});

		new VideoModal();
		new Quiz();
		new TableOfContent();
		Menu.init();
		PostsFilter.init();
		Tooltip.init();
		new IEcheck();
		new ScrollTo();
		new Accordion();
		new QuestionAnswer();
		new CopyToClipboard();
		ArticleMenu.init();
		new ModuleMenu();
		new PageProgress();
		new CalculateReadingTime();

		document.querySelectorAll('[data-site-header]').forEach((el) => {
			new StickyMenu(el);
		});

		document.querySelectorAll('[data-fade]').forEach((el) => {
			new Fade(el);
		});

		document.querySelectorAll('[data-swiper-wrapper]').forEach((el) => {
			new Carousel(el);
		});

		document.querySelectorAll('[data-scrolling-texts]').forEach((el) => {
			new ScrollText(el);
		});

		document.querySelectorAll('[data-horizontal-carousel]').forEach((el) => {
			new HorizontalCarousel(el);
		});

		document.querySelectorAll('[data-campagnes-module]').forEach((module) => new CampagnesModule(module));

		if (jQuery) {
			jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
				const emptyPrices = document.querySelectorAll('.gfield-choice-input[value="0|0"]');

				emptyPrices.forEach((input) => {
					input.parentElement.classList.add('custom-price-toggle');
					input.parentElement.insertAdjacentHTML('beforebegin', '<div class="line-break"></div>');
				});

				const form = document.querySelector(`#gform_wrapper_${form_id} form`);

				if (form) {
					new PostcodeCheck(form);
				}
			});
		}

		document.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			if (!e.target.closest('input[type="submit"].gform_button')) {
				return;
			}

			const checkboxes = e.target.closest('form').querySelectorAll('input[type="checkbox"][data-url]');

			for (const checkbox of checkboxes) {
				if (checkbox.checked && checkbox.dataset.url) {
					window.open(checkbox.dataset.url, '_blank');
					break;
				}
			}
		});

		document.dispatchEvent(new Event('bless'));
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new NatuurEnMilieu();
